import { replaceS3Url } from "components/Common/ReplaceS3Url"
import React, { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import {
  Card,
  Container,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Button,
} from "reactstrap"
import axios from "axios"

// UploadDocs Component
const UploadDocs = ({ doc, onClose }) => {
  const navigate = useNavigate()
  const [file, setFile] = useState(null)

  const handleSubmit = async cat_id => {
    if (!file) {
      toast.error("Please select a file before uploading")
      return
    }

    try {
      const formData = new FormData()
      formData.append("files", file)
      formData.append("cat_id", doc.cat_id)

      const response = await axios.post(
        "https://marcopolo.prisms.in/api/StudentProfilePic/upload-student-documents",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: JSON.parse(localStorage.getItem("Token")),
          },
        }
      )

      if (response.status === 200) {
        toast.success("uploaded successfully")
        navigate("/student-profile")
        onClose() // Close modal on success
      } else {
        toast.error("Failed to upload document")
      }
    } catch (error) {
      console.error("Upload error:", error)
      toast.error("An error occurred during upload")
    }
  }

  return (
    <div>
      <h5>Edit Document: {doc?.category}</h5>
      <Input type="file" onChange={e => setFile(e.target.files[0])} />
      <div className="d-flex justify-content-end mt-3">
        <Button color="secondary" className="me-2" onClick={onClose}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Upload
        </Button>
      </div>
    </div>
  )
}

// Home Component
const Home = () => {
  const location = useLocation()
  const documents = location.state?.documents || []
  const edit = location.state?.edit || []

  console.log(documents)

  const [previewUrl, setPreviewUrl] = useState("")
  const [previewType, setPreviewType] = useState("")
  const [modalOpen, setModalOpen] = useState(false)

  const [editModalOpen, setEditModalOpen] = useState(false)
  const [docToEdit, setDocToEdit] = useState(null)

  const toggleModal = () => setModalOpen(!modalOpen)

  const openEditModal = doc => {
    setDocToEdit(doc)
    setEditModalOpen(true)
  }

  const closeEditModal = () => {
    setEditModalOpen(false)
    setDocToEdit(null)
  }

 const handleView = url => {
  if (!url) {
    toast.warning("No document found to preview.")
    return
  }

  const finalUrl = replaceS3Url(url)
  const fileType = finalUrl.split(".").pop().toLowerCase()

  if (fileType === "pdf") {
    setPreviewType("pdf")
  } else if (
    ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(fileType)
  ) {
    setPreviewType("image")
  } else {
    setPreviewType("unknown")
  }

  setPreviewUrl(finalUrl)
  setModalOpen(true)
}


  return (
    <div className="page-content">
      <Container className="p-0">
        <Card className="p-0">
          <CardBody className="p-0">
            <h1 className="text-center mb-4 fs-3" style={{ color: "#3c3c3c" }}>
              Documents
            </h1>
            {documents.length === 0 ? (
              <p>No documents found.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Category</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents.map((doc, index) => (
                      <tr key={doc.cat_id}>
                        <td>{index + 1}</td>
                        <td>{doc.category}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {doc.viewable_by_parents === 1 ? (
                            <button
                              onClick={() => handleView(doc.name)}
                              className="btn btn-link p-0 me-3"
                              title="View"
                              style={{ fontSize: "1.3rem", color: "#0d6efd" }}
                            >
                              <i className="bx bx-show"></i>
                            </button>
                          ) : null}

                          {doc.viewable_by_parents === 1 ? (
                            <a
                              href={doc.name !== "" && doc.name !== null && replaceS3Url(doc.name)}
                              download
                              className="btn btn-link p-0 me-3"
                              title="Download"
                              style={{ fontSize: "1.3rem", color: "#198754" }}
                            >
                              <i className="bx bx-download"></i>
                            </a>
                          ) : null}

                          {doc.editable_by_parents === 1 ? (
                            <button
                              onClick={() => openEditModal(doc)}
                              className="btn btn-link p-0"
                              title="Edit"
                              style={{ fontSize: "1.3rem", color: "#ffc107" }}
                            >
                              <i className="bx bx-edit-alt"></i>
                            </button>
                          ) : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </CardBody>
        </Card>
      </Container>

      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Document Preview</ModalHeader>
        <ModalBody style={{ textAlign: "center" }}>
          {previewType === "pdf" ? (
            <iframe
              src={`https://docs.google.com/gview?url=${encodeURIComponent(
                replaceS3Url(previewUrl)
              )}&embedded=true`}
              title="PDF Preview"
              width="100%"
              height="600px"
              style={{ border: "none" }}
            ></iframe>
          ) : previewType === "image" ? (
            <img
              src={previewUrl}
              alt="Document"
              style={{ maxWidth: "100%", maxHeight: "500px" }}
            />
          ) : (
            <p>Unsupported file format for preview.</p>
          )}
        </ModalBody>
      </Modal>

      <Modal isOpen={editModalOpen} toggle={closeEditModal}>
        <ModalHeader toggle={closeEditModal}>Edit Document</ModalHeader>
        <ModalBody>
          <UploadDocs doc={docToEdit} onClose={closeEditModal} />
        </ModalBody>
      </Modal>
    </div>
  )
}

export default Home
